import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { Header } from "./components/Header";
import { ShimmerTable } from "react-shimmer-effects";
import toast, { Toaster } from "react-hot-toast";

const API_URL = "/api";

export default function CompanyInformation() {
  const { id } = useParams();
  const [companyNew, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [companyID, setCompanyID] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/getCompanyProfilesList/${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setCompany(data);
        setCompanyID(data?.COMPANYID);

        const comId = data?.COMPANYID;
        console.log("Company:", data);

        if (comId) {
          const response1 = await fetch(
            `${API_URL}/getComapnyProfile/${comId}`
          );
          if (!response1.ok) {
            throw new Error(`HTTP error! Status: ${response1.status}`);
          }
          const data1 = await response1.json();
          setCompany(data);
          console.log("Company:", data1);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyDetails();
  }, []);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setFormData({ ...companyNew }); // reset the form
    setIsEditing(false);
  };

  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const { _id, ...rest } = formData;
    if (!_id) {
      alert("Missing _id");
      return;
    }
    // Remove any fields with undefined values
    const cleanedData = {};
    for (const key in rest) {
      if (rest[key] !== undefined) {
        cleanedData[key] = rest[key];
      }
    }
    const updatePayload = {
      _id: _id, // Make sure it's a string
      update_data: cleanedData,
    };

    try {
      const response = await fetch(
        "http://localhost:8000/riverchain/techop/v1.1/updateCompanyLog",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        }
      );

      const resultText = await response.text();

      if (!response.ok) {
        console.error("❌ Update failed:", resultText);
        alert("Update failed:\n" + resultText);
      } else {
        toast.success("Company log updated successfully");
      }
    } catch (error) {
      console.error("🚨 Network error:", error);
      toast.danger("An error occurred while updating the profile.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app-container">
      <Toaster />
      <div className="container-fluid">
        <main className="content">
          <Header />
        </main>
      </div>

      <div className="container">
        <div className="row mt-4">
          <div className="col-md-12">
            <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
              Back to Company Log
            </NavLink>

            <br />

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ marginTop: "15px" }}>Company Information</h3>
              <div>
                {isEditing && (
                  <button
                    className="btn btn-secondary me-2 btn-sm"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                )}
                <button
                  className="btn btn-primary btn-sm"
                  onClick={async () => {
                    if (isEditing) {
                      setIsSubmitting(true);
                      await handleSubmit();
                      setIsSubmitting(false);
                    } else {
                      setFormData({ ...companyNew });
                      setIsEditing(true);
                    }
                  }}
                  disabled={isSubmitting}
                >
                  {isEditing
                    ? isSubmitting
                      ? "Submitting..."
                      : "Submit"
                    : "Edit"}
                </button>
              </div>
            </div>

            {loading || !companyNew ? (
              <ShimmerTable row={5} col={5} />
            ) : (
              <>
                <table className="table table-bordered">
                  <tbody>
                    {[
                      { label: "Borrower", key: "Borrower" },
                      { label: "Status", key: "Status" },
                      { label: "Underwriter", key: "Underwriter" },
                      { label: "Borrower Score", key: "BorrowerScore" },
                      { label: "Borrower Rating", key: "BorrowerRating" },
                      {
                        label: "Date of Rating",
                        key: "DateofRating",
                        type: "date",
                      },
                      { label: "Revenue", key: "Revenue" },
                      { label: "AccountNo", key: "AccountNo" },
                      { label: "Bank Account", key: "BankAccount" },
                      { label: "Bank Code", key: "BankCode" },
                      { label: "Bank Holder Name", key: "BankHolderName" },
                      {
                        label: "Litigation Search Date",
                        key: "LitigationSearchDate",
                        type: "date",
                      },
                      {
                        label: "Windingup Search Date",
                        key: "WindingupSearchDate",
                        type: "date",
                      },
                    ].map(({ label, key, type }) => (
                      <tr key={key}>
                        <td>{label}</td>
                        <td
                          style={{
                            textAlign: "right",
                            backgroundColor: "#fdf3d0",
                            width: "50%",
                          }}
                        >
                          {isEditing ? (
                            type === "date" ? (
                              <input
                                type="date"
                                value={
                                  formData?.[key]
                                    ? new Date(formData[key])
                                        .toISOString()
                                        .split("T")[0]
                                    : ""
                                }
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    [key]: e.target.value,
                                  }))
                                }
                                className="form-control form-control-sm"
                                style={{ textAlign: "right" }}
                              />
                            ) : (
                              <input
                                type="text"
                                value={formData?.[key] ?? ""}
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    [key]: e.target.value,
                                  }))
                                }
                                className="form-control form-control-sm"
                                style={{ textAlign: "right" }}
                              />
                            )
                          ) : type === "date" ? (
                            companyNew?.[key] ? (
                              formatDateToDDMMYYYY(companyNew[key])
                            ) : (
                              ""
                            )
                          ) : (
                            companyNew?.[key]
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
